/**
 * @generated SignedSource<<c70fc802d7e551cdfc67dee8e8929767>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type contentUtilsGetEntityIdsByQueueItemQueueItemsEdge$data = ReadonlyArray<{
  readonly node: {
    readonly entityId?: string;
  };
  readonly " $fragmentType": "contentUtilsGetEntityIdsByQueueItemQueueItemsEdge";
}>;
export type contentUtilsGetEntityIdsByQueueItemQueueItemsEdge$key = ReadonlyArray<{
  readonly " $data"?: contentUtilsGetEntityIdsByQueueItemQueueItemsEdge$data;
  readonly " $fragmentSpreads": FragmentRefs<"contentUtilsGetEntityIdsByQueueItemQueueItemsEdge">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "contentUtilsGetEntityIdsByQueueItemQueueItemsEdge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "entityId",
              "storageKey": null
            }
          ],
          "type": "Content",
          "abstractKey": "__isContent"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "QueueItemsEdge",
  "abstractKey": null
};

(node as any).hash = "75f13082e20fe19b8740aeeb3c82f386";

export default node;
